import { createContext, type Dispatch, use } from 'react';
import type { UserReducerActions, UserState } from './user.state';

export const UserContext = createContext<{ state: UserState; dispatch: Dispatch<UserReducerActions> }>({
  state: { auth: false },
  dispatch: () => undefined,
});

export const useUser = () => {
  const context = use(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserManagerProvider');
  }
  return context;
};
